var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',{staticClass:"title is-size-4-mobile"},[_vm._v(_vm._s(_vm.$t('general.region')))]),_vm._l((_vm.text),function(block){return _c('TemplateTextBlock',{key:block.headline,attrs:{"block":block}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }